import * as React from 'react';

interface DashboardPanelProps {
    headerText?: string;
    isDouble?: boolean;
    children?: any;
}

export const DashboardPanel = ({ children, headerText, isDouble }: DashboardPanelProps) => (
    <div className={`panel${isDouble ? ' double' : ''}`}>
        {headerText}
        {children}
    </div>
);



// WEBPACK FOOTER //
// ./src/components/pages/admin/DashboardPanel.tsx